import * as SH from 'react-syntax-highlighter/dist/light';
import * as SHStyle from 'react-syntax-highlighter/dist/styles/school-book';
import js from 'react-syntax-highlighter/dist/languages/javascript';
import css from 'react-syntax-highlighter/dist/languages/css';
import xml from 'react-syntax-highlighter/dist/languages/xml';
import bash from 'react-syntax-highlighter/dist/languages/bash';
import json from 'react-syntax-highlighter/dist/languages/json';
export var initializeSyntaxHighlights = function () {
    var registerLanguage = SH.registerLanguage;
    registerLanguage('javascript', js);
    registerLanguage('css', css);
    registerLanguage('xml', xml);
    registerLanguage('bash', bash);
    registerLanguage('json', json);
};
export var getSyntaxHighlightStyle = function () {
    return SHStyle.default;
};
export var SyntaxHighlighter = SH.default;
//# sourceMappingURL=index.js.map